export default __webpack_public_path__ + "static/media/Hands_Aqua.99438a0f.png";